<div class="app-list-filter-group">
  <ng-content></ng-content>
</div>
